module.exports = __webpack_public_path__ + "static/media/shoes.dd4a67ab.svg";